import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faFilePdf, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import Cookies from 'js-cookie/src/js.cookie';
import CookieConsent from 'vanilla-cookieconsent/src/cookieconsent';

export default {
  init() {
    // JavaScript to be fired on all pages

    $('#offcanvas-button-open').click(function () {
      $('#offcanvas').toggleClass('navbar-visible');
      $('body').toggleClass('prevent-scrolling');
    });

    $('#offcanvas-button-close').click(function () {
      $('#offcanvas').toggleClass('navbar-visible');
      $('body').toggleClass('prevent-scrolling');
    });

    $('#offcanvas-search-button-open').click(function () {
      $('#offcanvas-search').toggleClass('navbar-visible');
      $('body').toggleClass('prevent-scrolling');
    });

    $('#offcanvas-search-button-close').click(function () {
      $('#offcanvas-search').toggleClass('navbar-visible');
      $('body').toggleClass('prevent-scrolling');
    });

    $('.article-container').hover(function () {
      $(this).animate({ backgroundColor: "#e9902c" }, {duration:900});
    });

    if($('body').hasClass('page')){
      $('.sk-accordion').each(function(){
        if($(this).find('iframe').length > 0)
          $(this).find('.uk-accordion-title').html($(this).find('.uk-accordion-title').html() + '<span uk-icon="icon: play-circle" style="margin-left: 6px;"></span>');
      });
    }

    //scrollspy per collapse header
    $(document).scroll(function(){
      if($(this).scrollTop() > 0)
        $('header.banner nav.navbar-container').addClass('collassa');
      else
        $('header.banner nav.navbar-container').removeClass('collassa');
    });

    // add the imported icons to the library
    library.add(faFilePdf, faInfoCircle);

    // tell FontAwesome to watch the DOM and add the SVGs when it detects icon markup
    dom.watch()

    $.fn.datepicker.dates['fur'] = {
      days: ["Domenie", "Lunis", "Martars", "Miercus", "Joibe", "Vinars", "Sabide"],
      daysShort: ["Dom", "Lun", "Mar", "Mie", "Joi", "Vin", "Sab"],
      daysMin: ["Do", "Lu", "Ma", "Mi", "Jo", "Vi", "Sa"],
      months: ["Zenâr", "Fevrâr", "Març", "Avrîl", "Mai", "Jugn", "Lui", "Avost", "Setembar", "Otubar", "Novembar", "Dicembar"],
      monthsShort: ["Zen", "Fev", "Mar", "Avr", "Mai", "Jug", "Lui", "Avo", "Set", "Otu", "Nov", "Dic"],
      today: "Vuê",
      clear: "Cancele",
      format: "dd/mm/yyyy",
      titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
      weekStart: 0,
    };

    var lang = jQuery("html").attr("lang");
    lang = lang.split("-")[0];

    //init datepicker
    jQuery('.datepicker').datepicker({
      format: 'dd-mm-yyyy',
      autoclose: true,
      language: lang,
    });
  },
  finalize() {
    var cookieconsent = CookieConsent;
    cookieconsent = window.initCookieConsent();

    cookieconsent.run({
      page_scripts: true,
      auto_language: 'document',
      autoclear_cookies: true,
      languages: {
        'en-US': {
          consent_modal: {
            title: 'We use cookies!',
            description: 'Hello, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. For further information you can consult our <a href="https://arlef.it/en/cookie-policy/">cookie policy</a> or <button type="button" data-cc="c-settings" class="cc-link">set up your cookie preferences.</button>',
            primary_btn: {
                text: 'Accept all',
                role: 'accept_all',              // 'accept_selected' or 'accept_all'
            },
            secondary_btn: {
                text: 'Reject all',
                role: 'accept_necessary',        // 'settings' or 'accept_necessary'
            },
          },
          settings_modal: {
            title: 'Cookie preferences',
            save_settings_btn: 'Save settings',
            accept_all_btn: 'Accept all',
            reject_all_btn: 'Reject all',
            close_btn_label: 'Close',
            cookie_table_headers: [
                {col1: 'Name'},
                {col2: 'Domain'},
                {col3: 'Expiry'},
                {col4: 'Description'},
            ],
            blocks: [
              {
                title: 'Cookie usage 📢',
                description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details relative to cookies and other sensitive data, please read the full <a href="#" class="cc-link">privacy policy</a>.',
              },
              {
                title: 'Strictly necessary cookies',
                description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true,          // cookie categories with readonly=true are all treated as "necessary cookies"
                },
                cookie_table: [
                  {
                    col1: 'cc_cookie',
                    col2: 'arlef.it',
                    col3: '180 days',
                    col4: 'Stores the user\'s cookie preferences.',
                  },
                  {
                    col1: '_gat',
                    col2: 'arlef.it',
                    col3: '1 minute',
                    col4: 'This cookie is used to limit the number of requests that have to be made to Google. This cookie does not store any user information.',
                  },
                ],
              },
              {
                title: 'Analytics Cookies',
                description: 'These cookies allow to collect anonymous information about the user\'s behaviour on the website for statistical purposes.',
                toggle: {
                  value: 'analytics',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '^_ga',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '2 years',
                    col4: 'The _ga cookie is used to distinguish users and track the website\'s views.',
                    is_regex: true,
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '1 day',
                    col4: 'The _gid cookie is used to anonymously distinguish a single session.',
                  },
                ],
              },
              {
                title: 'Targeting / Advertising cookies',
                description: 'These cookies allow the website to remember the choices you have made in the past',
                toggle: {
                  value: 'advertising',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '_gcl_au',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '180 days',
                    col4: 'This cookie is used to track the user\'s conversions for specific landing pages.',
                    is_regex: true,
                  },
                  {
                    col1: '_fbp',
                    col2: 'facebook.com',
                    col3: '1 day',
                    col4: 'This cookie is used by Facebook to track the user\'s behaviour on the website.',
                  },
                ],
              },
            ],
          },
        },
        'it-IT': {
          consent_modal: {
            title: 'Informativa sull\'utilizzo dei Cookie',
            description: 'Questo sito o gli strumenti terzi da questo utilizzati si avvalgono di cookie necessari al funzionamento ed utili alle finalità illustrate nella cookie policy. Se vuoi saperne di più <button type="button" data-cc="c-settings" class="cc-link">clicca qui</button> o consulta la <a href="https://arlef.it/it/cookie-policy/">cookie policy</a>.',
            primary_btn: {
                text: 'Accetta tutti',
                role: 'accept_all',              // 'accept_selected' or 'accept_all'
            },
            secondary_btn: {
                text: 'Rifiuta i cookie non essenziali',
                role: 'accept_necessary',        // 'settings' or 'accept_necessary'
            },
          },
          settings_modal: {
            title: 'Preferenze Cookie',
            save_settings_btn: 'Salva impostazioni',
            accept_all_btn: 'Accetta tutti',
            reject_all_btn: 'Rifiuta tutti',
            close_btn_label: 'Chiudi',
            cookie_table_headers: [
                {col1: 'Name'},
                {col2: 'Domain'},
                {col3: 'Expiration'},
                {col4: 'Description'},
            ],
            blocks: [
              {
                title: 'Cookie usage',
                description: 'Questo sito fa utilizzo di cookies per garantirne le funzionalità base, migliorare la vostra esperienza e rilevare metriche statistiche sul suo utilizzo. Potete concedere o negare il vostro consenso per le singole categorie di utilizzo. Per ulteriori dettagli e informazioni sull\'utilizzo dei cookies si prega di consultare la cookie policy.',
              },
              {
                title: 'Cookie tecnici',
                description: 'Questi cookie sono essenziali per il corretto funzionamento del sito.',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true,          // cookie categories with readonly=true are all treated as "necessary cookies"
                },
                cookie_table: [
                  {
                    col1: 'cc_cookie',
                    col2: 'arlef.it',
                    col3: '180 giorni',
                    col4: 'Archivia le preferenze sulle categorie di cookies abilitate espresse dall\'utente',
                  },
                  {
                    col1: '_gat',
                    col2: 'arlef.it',
                    col3: '1 minuto',
                    col4: 'Regola il flusso delle richieste inviate ai servizi Google. Non registra dati relativi all\'utente.',
                  },
                ],
              },
              {
                title: 'Cookie Analytics',
                description: 'Questi cookie permettono il tracciamento anonimo dei comportamenti degli utenti sul sito a fini statistici.',
                toggle: {
                  value: 'analytics',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '^_ga',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '2 years',
                    col4: 'Il cookie _ga è un cookie che permette di numerare le visite del sito e quindi conoscere l’efficacia dello stesso',
                    is_regex: true,
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '1 giorno',
                    col4: 'Il cookie _gid è un cookie adibito all’identificazione della sessione.',
                  },
                ],
              },
              {
                title: 'Cookie di profilazione',
                description: 'Questi cookie creano profili personalizzati relativi all’utente per finalità pubblicitarie come l\'advertising sui social network.',
                toggle: {
                  value: 'advertising',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '_gcl_au',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '180 giorni',
                    col4: 'Il cookie _gcl_au è utilizzato per il tracciamento delle conversioni dell\'utente all\'interno di landing pages specifiche.',
                    is_regex: true,
                  },
                  {
                    col1: '_fbp',
                    col2: 'facebook.com',
                    col3: '1 giorno',
                    col4: 'Utilizzato da Facebook per offrire una serie di prodotti pubblicitari come le offerte in tempo reale di inserzionisti di terze parti.',
                  },
                ],
              },
            ],
          },
        },
        'fur-FUR': {
          consent_modal: {
            title: 'Informative sul ûs dai cookies',
            description: 'Chest sît al dopre cookies par garantî lis funzions di fonde, miorâ la vuestre esperience e rilevâ dâts statistics sul so ûs. O podês concedi o dineâ il vuestri consens par ognidune des categoriis di utilizazion. Par savê di plui <button type="button" data-cc="c-settings" class="cc-link">Impostazions dai cookies</button> - <a href="https://arlef.it/cookie-policy/">Cookie policy</a>.',
            primary_btn: {
                text: 'Acete dut',
                role: 'accept_all',              // 'accept_selected' or 'accept_all'
            },
            secondary_btn: {
                text: 'Refude dut',
                role: 'accept_necessary',        // 'settings' or 'accept_necessary'
            },
          },
          settings_modal: {
            title: 'Preferencis dai cookies',
            save_settings_btn: 'Salve impostazions',
            accept_all_btn: 'Acete dut',
            reject_all_btn: 'Refude dut',
            close_btn_label: 'Siere',
            cookie_table_headers: [
                {col1: 'Non'},
                {col2: 'Domini'},
                {col3: 'Scjadince'},
                {col4: 'Descrizion'},
            ],
            blocks: [
              {
                title: 'Ûs dai cookies',
                description: 'Chest sît al dopre cookies par garantî lis funzions di fonde, miorâ la vuestre esperience e rilevâ dâts statistics sul so ûs. O podês concedi o dineâ il vuestri consens par ognidune des categoriis di utilizazion. Par plui detais e informazions sul ûs dai cookies, si pues consultâ la Cookie policy.',
              },
              {
                title: 'Cookies tecnics',
                description: 'Chescj cookies a son essenziâi par podê fâ funzionâ in maniere corete il sît e doprâ dutis lis sôs funzions.',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true,          // cookie categories with readonly=true are all treated as "necessary cookies"
                },
                cookie_table: [
                  {
                    col1: 'cc_cookie',
                    col2: 'arlef.it',
                    col3: '180 diis',
                    col4: 'Salve lis impostazions pai cookies dal utent.',
                  },
                  {
                    col1: '_gat',
                    col2: 'arlef.it',
                    col3: '1 minuto',
                    col4: 'Chest cookie si dopre par limitâ il numar di domandis mandadis ai servizis Google. Chest Cookie nol regjistre dâts dal utent.',
                  },
                ],
              },
              {
                title: 'Cookie Analytics',
                description: 'Chescj cookies a permetin di olmâ in maniere anonime informazions sul compuartament dal utent sul sît par resons statistichis.  ',
                toggle: {
                  value: 'analytics',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '^_ga',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '2 years',
                    col4: 'Il cookie _ga al permet di contâ il numar di visitis al sît e duncje di cognossi la sô eficacitât.',
                    is_regex: true,
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '1 giorno',
                    col4: 'Il cookie _glc_au si dopre par olmâ lis conversions dal utent dentri di landing pages specifichis.',
                  },
                ],
              },
              {
                title: 'Cookies di marketing',
                description: 'Chescj cookies a crein profîi personalizâts peâts al utent par fins publicitaris tant che lis publicitâts sui social networks.',
                toggle: {
                  value: 'advertising',     // your cookie category
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [             // list of all expected cookies
                  {
                    col1: '_gcl_au',       // match all cookies starting with "_ga"
                    col2: 'google.com',
                    col3: '180 giorni',
                    col4: 'Il cookie _glc_au si dopre par olmâ lis conversions dal utent dentri di landing pages specifichis.',
                    is_regex: true,
                  },
                  {
                    col1: '_fbp',
                    col2: 'facebook.com',
                    col3: '1 giorno',
                    col4: 'Chest cookie al è doprât di Facebook par olmâ il compuartament dal utent sul sît.',
                  },
                ],
              },
            ],
          },
        },
      },
    });

    function acceptCookies() {
      Cookies.set('cookie_banner', '1', { expires: 365 });
      jQuery(".banner-cookies").addClass("d-none");
    }

    if($(document).find('#cookie-banner-close').length > 0)
      document.getElementById('cookie-banner-close').addEventListener('click', acceptCookies);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js